(() => {
  const ewPeriodCheckbox = $(
    ".product-template-sl-ew-addon [name='ew-period']"
  );
  const ewCheckbox = $(
    ".product-template-sl-ew-addon [name='extended-warranty']"
  );
  const selected_variantId = $(".selected_variantId");

  ewPeriodCheckbox.on("change", function () {
    if ($(this).is(":checked")) {
      ewPeriodCheckbox.not(this).prop("checked", false);
      handleSelectEW();
    } else {
      handleSelectEW(true);
      return;
    }
  });

  ewCheckbox.on("change", function () {
    updateSelectedEW();
  });

  const updateSelectedEW = () => {
    // set/clear variant(s) to be added to cart

    const text = ewCheckbox
      .filter(":checked")
      .map(function () {
        return this.value;
      })
      .get();
    
    const curVariant = $("#currentSelection").attr("data-variant");
    const variantOption = $(
      `#ProductSelect-product-template option[value='${curVariant}']`
    );
    const title =
      variantOption.attr("data-title") || variantOption.attr("data-option");
    const titles = title.split(" / ");
    const length = titles.length;

    if (length == 4 && text.length == 1) {
      selected_variantId.text(`${text}-1`); //changed to 1, because it adds 2 items to cart
      return;
    }

    selected_variantId.text(text.join(","));
  };

  const updateEWPrices = () => {
    ewPeriodCheckbox.each((_, input) => {
      const compare_elem = $(input)
        .closest("label")
        .find(".price-container .compare-at-price");

      const price_elem = $(input)
        .closest("label")
        .find(".price-container .price");

      const value = $(input).val();

      const curVariant = $("#currentSelection").attr("data-variant");
      const variantOption = $(
        `#ProductSelect-product-template option[value='${curVariant}']`
      );
      const title =
        variantOption.attr("data-title") || variantOption.attr("data-option");
      const titles = title.split(" / ");
      const length = titles.length;

      //console.group("EW PRICE");
      //console.log("Current Variant:", title);
      //console.log("Split Titles:", titles);
      //console.log("Current Period:", value);
      /*console.log(
        "Available EW Variants:",
        ewCheckbox
          .map((_, el) => $(el).attr("data-title"))
          .get()
      );*/

      let warranties;
      let isDouble = false;

      if (length == 2) {
        // just door/gate
        warranties = ewCheckbox.filter(
          `input[data-title='${titles[0]} / ${value}']`
        );
      } else if (length == 4) {
        // door + gate
        warranties = ewCheckbox.filter(
          `input[data-title='${titles[0]} / ${value}'], input[data-title='${titles[2]} / ${value}']`
        );
        if (warranties.length == 1) isDouble = true;
      }
      /*
      console.log(
        "Searching For:",
        length == 2
          ? `${titles[0]} / ${value}`
          : [`${titles[0]} / ${value}`, `${titles[2]} / ${value}`]
      );

      console.log(
        "Matched:",
        warranties
          .map((_, el) => $(el).attr("data-title"))
          .get()
      );
      */
      //console.groupEnd();

      let compare = 0;
      let price = 0;

      warranties.each((_, w) => {
        compare += Number($(w).attr("data-compare"));
        price += Number($(w).attr("data-price"));
      });

      if (isDouble) {
        compare = compare * 2;
        price = price * 2;
      }

      compare_elem.text(theme.Currency.formatMoney(compare).replace(".00", ""));
      price_elem.text(theme.Currency.formatMoney(price).replace(".00", ""));

      compare_elem.removeClass("hide");
    });
  };

  const handleSelectEW = (clear = false) => {
    $(".product-template-sl-ew-addon [name='extended-warranty']:checked").prop(
      "checked",
      false
    );

    const curPeriod = ewPeriodCheckbox.filter(":checked").val();

    if (clear || !curPeriod) {
      // if no ew addon selected
      ewCheckbox.trigger("change");
      return;
    }

    const curVariant = $("#currentSelection").attr("data-variant");
    const variantOption = $(
      `#ProductSelect-product-template option[value='${curVariant}']`
    );
    const title =
      variantOption.attr("data-title") || variantOption.attr("data-option");
    const titles = title.split(" / ");
    const length = titles.length;

    //console.group("EW SELECT");
    //console.log("Current Variant:", title);
    //console.log("Split Titles:", titles);
    //console.log("Selected Period:", curPeriod);

    if (length == 2) {
      // just door/gate
      ewCheckbox
        .filter(`input[data-title='${titles[0]} / ${curPeriod}']`)
        .prop("checked", true);
    } else if (length == 4) {
      // door + gate
      ewCheckbox
        .filter(
          `input[data-title='${titles[0]} / ${curPeriod}'], input[data-title='${titles[2]} / ${curPeriod}']`
        )
        .prop("checked", true);
        console.log(
          "Checked:",
          ewCheckbox
            .filter(":checked")
            .map((_, el) => $(el).attr("data-title"))
            .get()
        );

        //console.groupEnd();
            }


    ewCheckbox.trigger("change");
  };

  const watchCurSelection = () => {
    let target = $("#currentSelection")[0];

    let observer = new MutationObserver(function (mutations) {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName == "data-variant"
        ) {
          // run when main variant change
          updateEWPrices();
          handleSelectEW();
        }
      });
    });

    observer.observe(target, {
      attributes: true,
    });
  };

  watchCurSelection();
  updateEWPrices();
})();
